import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import { Link } from 'react-router-dom';
import $ from 'jquery';
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const JobList: FC = () => {
      const intl = useIntl();
      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
   
      const [jobList, setAvailableJobsList] = useState([]);
     const Pagesize=10;
    

      const siteId = '2';
      const loc = [];
      const cat = [];
      const education = [];
      const  type=[];
  useEffect(() => 
      {         
        //getAdminProfilesList(ITEMS_PER_PAGE,'1','','');
        //getEventList(siteId);      
       //filterJobsList(ITEMS_PER_PAGE,'1');
        filterJobListCall(ITEMS_PER_PAGE,'1');
      

      },[]);

      const searchList = () => {
        filterJobListCall(ITEMS_PER_PAGE,'1'); 
      } 

      const filterJobListCall = (ITEMS_PER_PAGE,pageNumber) => {     
        var status = 'published';
        var titleKeyWord:any =$('#search_input').val();
        var sortDir = '';
        var sortBy = '';
        var searchTxt:any = $('#search_input').val();

        var encoded_titleKeyWord = encodeURIComponent(titleKeyWord.trim());
        var encoded_searchTxt = encodeURIComponent(searchTxt.trim());

        services.getAdminJobList(siteId,encoded_titleKeyWord,status,pageNumber,ITEMS_PER_PAGE,sortBy,sortDir,encoded_searchTxt).then((res) => 
        {
          console.log("##################");
          console.log(JSON.stringify(res));
          if(res.data){
            setAvailableJobsList(res.data.content);

            setTotalItems(res.data.totalElements);         
            settotalPages(Math.ceil(res.data.totalElements / ITEMS_PER_PAGE));                    
            setCurrentPage(pageNumber);
          }
         

        });
        
      }
      const filterJobsList = (ITEMS_PER_PAGE,pageNumber) => {          
        
        const requestObject = {
            "jobCategory": cat,
            "jobLocation": loc,
            "jobEducation": education,
            "jobType": type,
            "pageSize": ITEMS_PER_PAGE,
            "pageNumber": pageNumber,
            "sortBy": "jobId",
            "sortDir": "desc",
            "siteId":siteId

        }
        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': "Bearer "+accessTokenIn 
                //'Authorization': accessTokenIn 
            },
            body: JSON.stringify(requestObject)
        };
       console.log(requestObject);
        services.jobsList(requestOptions).then((res) => 
        {
          console.log("#################80");
          console.log(res) 
          if(res.content){
                setAvailableJobsList(res.content);

                console.log("company jobs list@@@@@@@" + JSON.stringify(res.content));

                setTotalItems(res.totalElements);         
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));                    
                setCurrentPage(pageNumber);
            }             

        });
}
      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
       // filterJobsList(ITEMS_PER_PAGE,offset);
        filterJobListCall(ITEMS_PER_PAGE,offset);
      };
      
      
    
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Jobs List'})}</PageTitle>
         
        <div className={`card`}>



     
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>



        <table className=''>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>                
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
          
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                {/*<th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-150px'>Posted On</th>
                <th className='min-w-140px'>Job Title</th>
                <th className='min-w-120px'>Company Name</th>            
               
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {	
	          jobList.map((data, index) => (
              <tr>
               {/* <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                  </div>
                </td> */}
                <td>
                  {/* <a href={'/editjob?job_id='+data.jobDetail.jobId} className='text-dark fw-bolder text-hover-primary fs-6'>
                  {moment(data.jobDetail.createdDate).format("D-MMM-YY")}</a> */}


                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+'&job_tab=R'}>{(data.createdDate=='' || data.createdDate==null) ? '--' : moment(data.createdDate).utcOffset('-0400').format("MM/DD/YYYY, HH:mm:ss")}</Link>

                </td>
                <td>
                  {/* <a href={'/editjob?job_id='+data.jobDetail.jobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
    {data.jobDetail.title}</a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+'&job_tab=R'}>{(data.jobTitle=='' || data.jobTitle==null) ? '--' : data.jobTitle}</Link>
                 
                </td>
                <td>
                  {/* <a href={'/editjob?job_id='+data.jobDetail.jobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {data.companyName}
                  </a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+'&job_tab=R'}>{(data.companyName=='' || data.companyName==null) ? '--' : data.companyName}</Link>
                 
                </td>
              
            
              
                <td className='text-end'>
                  {/* <a
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
                  </a> */}
                  {/* <a
                   href={'/editjob?job_id='+data.jobDetail.jobId}
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a> */}


                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/editjob?job_id='+data.jobId+'&job_tab=R'}>  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /></Link>
                  {/* <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                  </a> */}
                </td>
              </tr>
              ))}
              
            </tbody>
            {/* end::Table body */}
          </table>

          <Pagination
                
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
         
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>


          
        </>
      )
    }
export {JobList}